<template>
    <div>
        <div id="home" class="pc" v-if="devicetype==1">
            <div class="home_top">
                <img class="image" src="../../assets/images/logo.png" alt="">
                <div class="home_title">国际打击乐协会证书查询</div>
            </div>
            <div class="home_list">
                <div @click="enquiriesClick1" class="home_list_one">
                    <div class="home_list_title">会员资质查询</div>
                    <div class="home_list_border"></div>
                    <div class="home_list_bottom">Membership</div>
                </div>
                <div @click="enquiriesClick4" class="home_list_four">
                    <div class="home_list_title">赛事证书查询</div>
                    <div class="home_list_border"></div>
                    <div class="home_list_bottom">Membership</div>
                </div>
                <div @click="enquiriesClick2" class="home_list_two">
                    <div class="home_list_title">师资证书查询</div>
                    <div class="home_list_border"></div>
                    <div class="home_list_bottom">Certify teacher</div>
                </div>
                <div @click="enquiriesClick3" class="home_list_three">
                    <div class="home_list_title">考试证书查询</div>
                    <div class="home_list_border"></div>
                    <div class="home_list_bottom">Certification</div>
                </div>
            </div>
            <div class="bottombar">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>
        </div>
        <div id="homephone" class="phone" v-if="devicetype==0">
            <div class="home_box" style="min-height:calc(100vh - 60px);overflow-y:auto">
                <div @click="enquiriesClick1()" class="home_box1">
                    <div class="home_hy">
                        会员资质查询
                    </div>
                    <div class="home_xx"></div>
                    <div class="home_y">
                        Membership
                    </div>
                </div>
                 <div @click="enquiriesClick4()" class="home_box4">
                    <div class="home_hy">
                        赛事证书查询
                    </div>
                    <div class="home_xx"></div>
                    <div class="home_y">
                        Certify teacher
                    </div>
                </div>
                <div @click="enquiriesClick2()" class="home_box2">
                    <div class="home_hy">
                        师资证书查询
                    </div>
                    <div class="home_xx"></div>
                    <div class="home_y">
                        Certify teacher
                    </div>
                </div>
                <div @click="enquiriesClick3()" class="home_box3">
                    <div class="home_hy">
                        考试证书查询
                    </div>
                    <div class="home_xx"></div>
                    <div class="home_y">
                        Certification
                    </div>
                </div>
            </div>
            <div class="padding-tb-20 text-center">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            devicetype:-1
        }
    },
    created(){
        this.loadDeviceType()
    },
    methods:{
        enquiriesClick1(){
            this.$router.push({path:'/enquiriespc',query: {type:1}})
        },
        enquiriesClick2(){
            this.$router.push({path:'/enquiriespc',query: {type:2}})
        },
        enquiriesClick3(){
            this.$router.push({path:'/enquiriespc',query: {type:3}})
        },
        enquiriesClick4(){
            this.$router.push({path:'/enquiriespc',query: {type:4}})
        },
        // 看是手机端还是pc端
        loadDeviceType() {
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i))) {
               this.devicetype = 0
            }
            else {
                this.devicetype = 1
            }
        }
    }
}
</script>

<style scoped>

#home{
    min-height: 100vh;
    background: #fff;
}

.pc .home_top{
    width: 100%;
    height: 120px;
    background: #4D4D4D;
    /* background: #fff; */
    display: flex;
    align-items: center;
}

.pc .image{
    /* 922*255 */
    /* width: 238px; */
    margin-left: 360px;
    height: 74px;
    width: 267px;
}

.pc .home_title{
    font-size: 26px;
    font-weight: 600;
    color: #FFFFFF;
    margin-left: 500px;
}

.pc .home_list{
    margin-left: 360px;
    margin-right: 360px;
    display: flex;
    margin-top: 261px;
}

.pc .home_list_one{
    width: 270px;
    height: 260px;
    background: linear-gradient(313deg, #56D9EF 0%, #05C7E8 100%);
    border-radius: 20px;
    flex: 1;
}

.pc .home_list_two{
    width: 270px;
    height: 260px;
    background: linear-gradient(313deg, #FDC52D 0%, #F99B1A 100%);
    border-radius: 20px;
    flex: 1;
   margin-left: 40px;
}

.pc .home_list_three{
    width: 270px;
    height: 260px;
    background: linear-gradient(313deg, #FF6C93 0%, #FF5466 100%);
    border-radius: 20px;
    flex: 1;
   margin-left: 40px;
}
.pc .home_list_four{
    width: 270px;
    height: 260px;
    background: linear-gradient( 313deg, #B97FFF 0%, #A054FF 100%);
    border-radius: 15px;
     flex: 1;
    margin-left: 40px;
}

.pc .home_list_title{
    width: 100%;
    text-align: center;
    font-size: 26px;
    font-weight: 500;
    margin-top: 83px;
    color: #FFFFFF;
}

.pc .home_list_border{
    width: 200px;
    height: 1px;
    border-bottom: 1px solid #FFFFFF;
    margin: 0 auto;
    margin-top: 15px;
}

.pc .home_list_bottom{
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-weight: 300;
    color: #FFFFFF;
    letter-spacing: 3px;
    margin-top: 10px;
}

#homephone{
    min-height: 100vh;
    background: #fff;
}
.phone .home_box{
    margin-left: 35px;
    margin-right: 35px;
    padding-top: 80px;
}
.phone .home_box1{
    height: 320px;
    background: linear-gradient(313deg, #56D9EF 0%, #05C7E8 100%);
    border-radius: 20px;
}
.phone .home_box2{
    height: 320px;
    background: linear-gradient(313deg, #FDC52D 0%, #F99B1A 100%);
    border-radius: 20px;
    margin-top: 40px;
}
.phone .home_box3{
    height: 320px;
    background: linear-gradient(313deg, #FF6C93 0%, #FF5466 100%);
    border-radius: 20px;
    margin-top: 40px;
}
.phone .home_box4{
    height: 320px;
    background: linear-gradient( 313deg, #B97FFF 0%, #A054FF 100%);
    border-radius: 20px;
    margin-top: 40px;
}
.phone .home_hy{
    width:100%;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    padding-top: 97px;
    line-height: 53px;
}
.phone .home_xx{
    width: 300px;
    border-bottom: 1px solid #FFFFFF;
    margin: 0 auto;
    margin-top: 9px;
}
.phone .home_y{
    font-size: 38px;
    font-weight: 300;
    color: #FFFFFF;
    width: 100%;
    text-align: center;
    margin-top: 5px;
    line-height: 53px;
    letter-spacing: 3px;
}
.phone .nav-style {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
}
.phone .top-t1-box{
    width:52%;
    display: flex;
    justify-content: center;
}
.phone .top-tl {
    font-size: 38px;
    color: #1A1A1A;
    font-weight: 600;
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
    /*超出部分文字以...显示*/
}
.phone .imac{
    width: 145px;
    height: 45px;
    margin-top: 10px;
    margin-left:35px;
}	

</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue